export default (state, primaryKey) => {
   //  const serverData = state.getIn(['wpServerData', primaryKey])
   //  const localData = state.getIn(['wpLocalData', primaryKey])

   //  return serverData.getIn(['data'])
   //                   .mergeDeep(localData.getIn(['data']))
   //                   .filter((k) => {
   //                       if(localData.has('deletedItems')) {
   //                          return !localData.getIn(['deletedItems']).has(k)
   //                       } else {
   //                          return true
   //                       }
   //                   });

   const serverData = state.getIn(['wpServerData', primaryKey])
   const localData = state.getIn(['wpLocalData', primaryKey])

   return serverData.getIn(['data'])
                     .mergeDeep(localData.getIn(['data']))
                     .filter((v,k) => {
                        if(localData.has('deletedItems')) {
                           return !localData.getIn(['deletedItems']).contains(k)
                        } else {
                           return true
                        }
                     });
}